import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { LettereDiffidaDatiGeneraliForm } from '../../../form/lettera-diffida-dati-generali-form';
import { SezioneLettereDiffidaResponse } from '../../../models/dto/sezione-lettere-diffida-response';
import { LetteraDiffida } from '../../../models/lettera-diffida';

import { SezioneLettereDiffidaFull } from '../../../models/sezioni/sezione-lettere-diffida-full';

@Component({
    selector: 'div [lettere-diffida-dati-generali-add-form]',
  templateUrl: '../../../form/lettera-diffida-dati-generali-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})
export class LettereDiffidaAddComponent extends LettereDiffidaDatiGeneraliForm implements OnInit {

  @Output() onReturn: EventEmitter<SezioneLettereDiffidaFull> = new EventEmitter<SezioneLettereDiffidaFull>();

  private idSezione: string;
  private idFascicolo: string;
  private urlAddLetteraDiffida: string;
  private urlReadSezioneControparti: string;

  constructor(@Inject(HelpersService) helpers: HelpersService, @Inject(OperationsService) operations: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder) {
    super(helpers, operations, campiForm);
  }

  ngOnInit() {
    this.setTitle('Aggiungi lettera diffida');
    this.isInserimento(true);
  }

  getUrlReadSezioneControparti() {
    return this.urlReadSezioneControparti;
  }

  getLetteraDiffida(): LetteraDiffida {
    return new LetteraDiffida();
  }

  getRequest(request: LetteraDiffida) {
    this.operations.addLetteraDiffida(this.urlAddLetteraDiffida, this.idSezione, this.idFascicolo, request).subscribe(response => this.returnSetSezLettereDiffida(response));
  }

  returnSetSezLettereDiffida(response: SezioneLettereDiffidaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(urlAddLetteraDiffida: string, idSezione: string, idFascicolo: string, urlReadSezioneControparti: string, idSezioneControparti: string) {
    this.idSezione = idSezione;
    this.urlAddLetteraDiffida = urlAddLetteraDiffida;
    this.urlReadSezioneControparti = urlReadSezioneControparti;
    this.idFascicolo = idFascicolo;
    if (idSezioneControparti) {
      this.readSezioneControparti(idSezioneControparti);
    }
    this.populateSelect(urlReadSezioneControparti, idSezioneControparti);
    this.createForm();
  }

}
